import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Anandkrushiparyatankendra() {



    const cardData =
    {
        keyword: 'Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism',
        heading: 'Anand Krushi Paryatan Kendra: Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism',
        headingDescription: 'Looking for a peaceful escape from the city? Anand Krushi Paryatan Kendra, set across 40 acres in Morachi Chincholi, just 55 km from Pune, offers a perfect day filled with nature, culture, and fun. Surrounded by lush green landscapes and fresh air, this destination is a prime spot for agro tourism in Maharashtra. As a top choice for Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism, the center offers a variety of rural experiences including bullock cart and tractor rides, horse riding, boating, swimming, and rain dance. Adventure lovers can enjoy traditional village games and children can delight in magic and puppet shows.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Early Morning Tractor Safari",
    "description": "Kickstart your rural retreat with a breezy tractor safari through expansive farmlands, vibrant marigold patches, and swaying mustard fields. This scenic ride offers panoramic views of the countryside, a chance to interact with local farmers, and moments to capture Instagram-worthy sunrise photos — all while sitting on a colorfully decorated traditional tractor that sets the tone for a truly rustic day."
  },
  {
    "title": "Hands‑On Organic Farming Experience",
    "description": "Participate in hands-on farming where you can sow seeds, pluck seasonal vegetables, and try composting methods used by real village farmers. Learn how organic food is grown using traditional techniques like bullock-ploughing, mulching, and drip irrigation. This immersive session fosters a deeper connection with the soil, and kids especially love digging in and discovering where their food comes from."
  },
  {
    "title": "Village‑Style Breakfast Feast",
    "description": "After working up an appetite, enjoy a farm-fresh breakfast made with love—think spicy misal-pav, tangy thecha served with bhakri, sabudana khichdi, and piping hot tea brewed over a wood-fired chulha. Served in a bamboo-covered seating area surrounded by lush greenery, this meal offers both nutrition and nostalgia, making it a highlight of your visit."
  },
  {
    "title": "Rural Games & Family Fun",
    "description": "Revisit your childhood with traditional Indian games like gilli-danda, lagori, kabaddi, kho-kho, and sack races. Large open grounds allow everyone to freely play, laugh, and bond—be it kids discovering new games or adults reliving theirs. The kendra also provides bamboo swings, rope walks, and tire-balancing zones to keep all age groups joyfully engaged."
  },
  {
    "title": "Nature Trail & Bird Watching",
    "description": "Wander along well-marked nature trails that weave through the farm’s outskirts and observe native flora and fauna in peace. Early morning or late afternoon strolls often include glimpses of parrots, kingfishers, bulbuls, and even peacocks fluttering by the banyan and tamarind trees. It’s a perfect activity for bird lovers and peace seekers alike."
  },
  {
    "title": "Interactive Dairy & Milking Demo",
    "description": "Witness and participate in the milking of cows using age-old hand techniques, guided by the farm's caretakers. Learn how milk is filtered, boiled, and turned into ghee or curd. Children especially enjoy feeding the calves or watching buffaloes bathe in the nearby pond — offering a wholesome view of rural dairy life that's both educational and fun."
  },
  {
    "title": "Rustic Lunch on Banana Leaves",
    "description": "Feast on an unlimited Maharashtrian thali served with love on fresh-cut banana leaves — featuring dishes like zunka-bhakar, bharli vangi, pithla, varan-bhat, pickles, and cooling taak. The authentic taste is enhanced by open-air seating, folk music, and a backdrop of swaying sugarcane fields. A truly soulful rural lunch that satisfies both your palate and heart."
  },
  {
    "title": "Craft Workshop: Pottery & Weaving",
    "description": "Join hands-on workshops where local artisans teach you the art of clay pottery, mud toys, and traditional weaving with banana fiber or jute. Paint your own diyas or make a tiny pot on the wheel, and take home a handcrafted souvenir made by you. These sessions are perfect for kids, creative adults, and couples seeking a unique, memorable experience."
  },
  {
    "title": "Water Splash Zone & Rain Dance",
    "description": "Unwind in the dedicated splash zone equipped with water jets, kiddie pools, and colorful slides. Groove under the rain dance canopy with lively Marathi beats or Bollywood DJ remixes. It’s a great way to cool off after a day of activities—especially loved by children and young adults during weekends, summer holidays, and group outings."
  },
  {
    "title": "Sunset Nature Stroll & Bonfire",
    "description": "As the sun sets behind the sugarcane fields, take a golden-hour stroll around the property or rest beneath the banyan tree to watch the sky change colors. Later, gather around a cozy bonfire with your group for folk tales, live music, bhadang-snacks, or even dholki singing. A soothing close to a lively rural day, perfect for creating lasting memories."
  }
],




"services": [
  {
    "name": "Agro Tourism Experiences at Anand Krushi Paryatan Kendra",
    "description": "Immerse yourself in authentic rural life with unique agro-tourism experiences at Anand Krushi Paryatan Kendra. Visitors can witness daily farming activities, interact with local farmers, enjoy homegrown food, and engage in community-based cultural programs—all in one vibrant farm environment."
  },
  {
    "name": "Hands-on Farming Activities",
    "description": "Get actively involved in real farm tasks—from planting seeds and watering crops to feeding livestock and learning composting techniques. Anand Krushi Paryatan Kendra provides a safe and educational platform for kids and adults to reconnect with the soil."
  },
  {
    "name": "Organic Farming Practices",
    "description": "Explore how nature-friendly agriculture works through guided sessions on organic farming. Learn about crop rotation, natural pest control, and green composting—all demonstrated within the farm’s operational areas by experienced local farmers."
  },
  {
    "name": "Seasonal Farm Festivals",
    "description": "Celebrate nature’s bounty during vibrant seasonal festivals hosted on the farm, including mango festivals, harvest feasts, and Sankranti celebrations. Guests can take part in folk dances, traditional games, and delicious Maharashtrian food during these festive events."
  },
  {
    "name": "Farm Stays and Cottages",
    "description": "Stay overnight in cozy, eco-friendly cottages surrounded by lush fields and bird calls. Anand Krushi Paryatan Kendra offers basic yet comfortable rural accommodations for families and couples looking to experience true countryside hospitality."
  },
  {
    "name": "Workshops on Traditional Farming",
    "description": "Dive into age-old agricultural wisdom with hands-on workshops that explore plowing, seed preservation, and irrigation techniques used by generations of Indian farmers. Ideal for students, agri-enthusiasts, and eco-learners."
  },
  {
    "name": "Bird Sanctuary Tours",
    "description": "Located within the peacock zone of Morachi Chincholi, the farm offers birdwatching tours where you can spot peacocks, parrots, and other native species in their natural habitat—perfect for bird lovers and nature photographers."
  },
  {
    "name": "Educational Visits for Schools",
    "description": "Anand Krushi Paryatan Kendra is a popular destination for school field trips. Students get to learn about sustainable farming, biodiversity, and food origins through interactive farm tours, nature games, and farming activities tailored to all age groups."
  },
  {
    "name": "Family-Friendly Farm Activities",
    "description": "Families can spend quality time enjoying bullock cart rides, petting farm animals, playing traditional games, and relaxing under shady trees. The environment is safe, child-friendly, and offers experiences suitable for all age groups."
  },
  {
    "name": "Local Crafts and Produce Stalls",
    "description": "Browse local stalls featuring handmade goods like bamboo crafts, jaggery, pickles, and seasonal farm produce. These stalls support rural artisans and offer guests a chance to take home authentic, locally-sourced souvenirs."
  },
  {
    "name": "Nature Trails Within the Farm",
    "description": "Explore curated nature trails running through vegetable gardens, fruit orchards, and wildflower zones. These peaceful paths are great for bird watching, photography, or simply a reflective walk in nature."
  },
  {
    "name": "Cultural Shows and Folk Performances",
    "description": "Weekend evenings often feature traditional folk dances, music performances, and rural storytelling sessions under the stars. These cultural showcases offer guests a deep dive into the rich heritage of Maharashtra’s villages."
  },
  {
    "name": "Eco-Tourism Initiatives",
    "description": "Anand Krushi Paryatan Kendra emphasizes sustainable practices such as water harvesting, solar energy use, waste segregation, and organic farming. Guests can learn about these eco-initiatives as part of the visit or through special guided sessions."
  },
  {
    "name": "Farm to Fork Experiences",
    "description": "Enjoy farm-fresh meals where most ingredients come straight from the fields. Taste seasonal produce, traditional recipes, and fresh dairy—all cooked on wood-fired chulhas to retain authentic village flavors."
  },
  {
    "name": "Adventure Activities on the Farm",
    "description": "In addition to peaceful walks and farming, the center offers fun rural adventure activities like rope bridges, tire climbing, obstacle games, and team challenges—perfect for school groups, corporate outings, or energetic family members."
  }
],
"tableData": [
  ["Agro Tourism Experiences at Anand Krushi Paryatan Kendra", "- Hands-on Farming Activities"],
  ["Organic Farming Practices", "- Seasonal Farm Festivals"],
  ["Farm Stays and Cottages", "- Workshops on Traditional Farming"],
  ["Bird Sanctuary Tours", "- Educational Visits for Schools"],
  ["Family-Friendly Farm Activities", "- Local Crafts and Produce Stalls"],
  ["Nature Trails Within the Farm", "- Cultural Shows and Folk Performances"],
  ["Eco-Tourism Initiatives", "- Farm to Fork Experiences"],
  ["Adventure Activities on the Farm", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Scenic and Short Drive from Pune",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra is located approximately 55 km from Pune via the Pune–Ahmednagar road. The 1–1.5 hour scenic drive through farmland and rural villages makes it a refreshing escape from the city."
  },
  {
    "WhyChooseheading": "Peacock Sanctuary in Natural Tamarind Groves",
    "WhyChoosedescription": "Morachi Chincholi is famed for its thriving population of thousands of peacocks. At Anand Krushi Paryatan, you can walk among flocks of peafowl and witness their vibrant displays and melodious calls—truly a unique wildlife experience in Maharashtra."
  },
  {
    "WhyChooseheading": "Hands-On Agritourism Activities",
    "WhyChoosedescription": "Experience authentic farming with tractor and bullock-cart rides, guided tours of organic fields, vegetable and fruit picking, and interactive sessions with farmers. Perfect for families, students, and nature lovers to learn traditional agriculture."
  },
  {
    "WhyChooseheading": "Rural Fun for All Ages",
    "WhyChoosedescription": "Enjoy a variety of entertainments like puppet and magic shows, rural games (like gilli-danda and marbles), animal feeding zones, and a children's play area. Ideal for energetic kids and nostalgic grown-ups!"
  },
  {
    "WhyChooseheading": "Adventure & Outdoor Sports",
    "WhyChoosedescription": "Add adventure with zip-lining, archery, rope climbing, boating near the farm pond, and friendly matches of cricket or volleyball. A rain-dance zone keeps the fun going during hot weather."
  },
  {
    "WhyChooseheading": "Cultural Festivals & Village Celebrations",
    "WhyChoosedescription": "Join in traditional events like winter Hurda parties (with roasted sorghum and jaggery) and summer Mango Mahotsav. Seasonal celebrations include folk music, lantern-lighting, and village feasts."
  },
  {
    "WhyChooseheading": "Farm-to-Table Dining Experience",
    "WhyChoosedescription": "Relish freshly prepared Maharashtrian food featuring organic produce from the farm—think jowar bhakri, seasonal sabzis, misal-pav, fresh salads, churned butter, and homemade desserts—all served outdoors."
  },
  {
    "WhyChooseheading": "Affordable, All-Inclusive Packages",
    "WhyChoosedescription": "Day packages start around ₹600 for adults and ₹300 for children, covering meals, activities, rides, and guided tours. Overnight stays with bonfires and stargazing are also available at very reasonable rates."
  }
]










    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What is Anand Krushi Paryatan Kendra known for in agro tourism?',
    answer: 'It offers immersive farm experiences—pony and tractor rides, butterfly and bird watching, interactive farm activities, and exposure to local agricultural practices—all in a rustic village setting.',
  },
  {
    id: 'FAQ2',
    question: 'Where is it located and how far from Pune?',
    answer: 'Situated in Morachi Chincholi village, Anand Krushi is about 65 km from Pune (approximately a 1.5‑hour drive), accessible via Alandi or Chakan.',
  },
  {
    id: 'FAQ3',
    question: 'What are the key agro‑tourism activities offered?',
    answer: 'Guests can take guided farm walks, participate in crop sowing or harvesting (seasonal), enjoy pony/cart/tractor rides, and observe butterflies, peacocks, and local birds.',
  },
  {
    id: 'FAQ4',
    question: 'Is the experience family‑friendly?',
    answer: 'Definitely—milking buffaloes, feeding farm animals, and gentle rides are fun for children, while adults appreciate the natural scenery and learning experiences.',
  },
  {
    id: 'FAQ5',
    question: 'Can schools or organizations book educational visits?',
    answer: 'Yes—educational and group bookings are encouraged, with customized tours covering farm life, ecology, and agrarian traditions.',
  },
  {
    id: 'FAQ6',
    question: 'What facilities do they have for visitors?',
    answer: 'Facilities include clean restrooms, shaded picnic areas, snack counters (farm‑to‑table), seating, parking for cars/two‑wheelers, and changing areas.',
  },
  {
    id: 'FAQ7',
    question: 'What is the ideal time to visit?',
    answer: 'The best season is monsoon through early winter (June–November), when crops are green, and wildlife like peacocks and butterflies are most active.',
  },
  {
    id: 'FAQ8',
    question: 'Are guided farm tours available?',
    answer: 'Yes—guided nature and farm tours are offered to educate guests about local flora, fauna, and sustainable agriculture practices.',
  },
  {
    id: 'FAQ9',
    question: 'Do we need to book in advance?',
    answer: 'Advance booking is recommended for weekends, holidays, or group visits to ensure a seamless experience and access to activities.',
  },
  {
    id: 'FAQ10',
    question: 'What should visitors bring along?',
    answer: 'Bring comfortable clothing, hats, sunscreen, insect repellent, water or light snacks, a camera, and optionally a picnic blanket.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Kulkarni, Pune',
    feedback: "Anand Krushi was a fantastic agro‑tourism discovery! My kids loved feeding the animals and watching butterflies, while I enjoyed learning about sustainable farming. A rejuvenating rural retreat.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ishita Patil, Corporate HR, Pune',
    feedback: "We hosted a corporate offsite here. The guided farm tour, interactive activities, and serene environment were perfect for team building. Great balance of learning and leisure!",
    rating: 5,
  },
];










    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism",
  "image": "https://morachichincholi.in/assets/images/agro-tourism-anand-krushi-paryatan-kendra.jpg",
  "description": "Explore authentic agro tourism at Anand Krushi Paryatan Kendra in Morachi Chincholi, Pune. Enjoy hands-on farming, bird sanctuary tours, eco-trails, seasonal festivals, cultural shows, farm stays, and local produce experiences.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2678"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "750",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/agro-tourism-anand-krushi-paryatan-kendra"
  }
};



    return (
        <div>
<Helmet>
  <title>Anand Krushi Paryatan Kendra Morachi Chincholi Pune Agro Tourism | Farm Stay, Nature & Culture</title>
  <meta 
    name="description" 
    content="Discover agro tourism at Anand Krushi Paryatan Kendra in Morachi Chincholi, Pune. Participate in farming activities, explore bird sanctuaries, enjoy cultural shows, farm-to-fork meals, eco-friendly stays, and more." 
  />
  <meta 
    name="keywords" 
    content="Agro tourism experiences at Anand Krushi Paryatan Kendra, Hands-on farming activities, Organic farming practices, Seasonal farm festivals, Farm stays and cottages, Workshops on traditional farming, Bird sanctuary tours, Educational visits for schools, Family-friendly farm activities, Local crafts and produce stalls, Nature trails within the farm, Cultural shows and folk performances, Eco-tourism initiatives, Farm to fork experiences, Adventure activities on the farm" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Anandkrushiparyatankendra;